import React from 'react'
import { useTranslation } from 'react-i18next'
import { FallbackProps } from 'react-error-boundary'

import { ResidentAppError } from '../../../common/error'

import { throwOnMovedOutWriteAccessDenied } from 'api/throwOnMovedOutWriteAccessDenied'
import { Error } from 'components/Error'
import { ResidentAppErrorBoundary } from 'components/ResidentAppErrorBoundary/ResidentAppErrorBoundary'

interface ErrorHandlerProps {
  children: React.ReactNode
}

export const ErrorHandler: React.FC<ErrorHandlerProps> = ({ children }) => {
  const [t] = useTranslation(['defectNotice'])

  const fallbackRender = ({ error }: FallbackProps) => {
    if (throwOnMovedOutWriteAccessDenied(error)) {
      throw error
    }

    if (error instanceof ResidentAppError) {
      switch (error.errorCode) {
        case 'DEFECT_NOTICE_MISSING_PHONE_NUMBER':
          return (
            <Error
              title={t('errors.missingUserPhoneNumber.title')}
              message={t('errors.missingUserPhoneNumber.message')}
              illustration="house-confused"
            />
          )

        case 'DEFECT_NOTICE_SUBMIT_ERROR':
          return <Error message={t('errors.submitError')} />

        default:
          return <Error message={t('errors.serviceUnavailable')} />
      }
    }

    return <Error message={t('errors.serviceUnavailable')} />
  }

  return (
    <ResidentAppErrorBoundary fallbackRender={fallbackRender}>
      {children}
    </ResidentAppErrorBoundary>
  )
}
